import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import EmployeeListLayer from "../components/EmployeeListLayer";

const EmployeeListPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                <EmployeeListLayer />
            </MasterLayout>
        </>
    );
};

export default EmployeeListPage;
